import AxiosInstance from './AxiosInstance';
import throttle from 'lodash.throttle';
import Singleton from '../core/singleton';
const interval = 1000;

const AxiosServices = {
    logout: () => AxiosInstance.get('crew/logout'),
    route: trip => AxiosInstance.post('crew/route', trip),
    translationsByLng: (lng = "en") => AxiosInstance.get(`translations/crew-app/${lng}`, {
        data: 'translationsByLng'
    }).then(data => {
        AxiosServices.content_role().then(content => {
            Singleton.getInstance().content_roles = content.data.content_roles;
        })
        if (Singleton.getInstance().authCredencials.token() !== null)
            AxiosInstance.defaults.headers.common['Authorization'] = Singleton.getInstance().authCredencials.token();

        return data;
    }),
    authenticate: registrationNumber => AxiosInstance.post('crew/authenticate', { "code": registrationNumber })
        .then(result => {
            let { token } = result.data;
            Singleton.getInstance().setAuthCredencials({ 'token': `Bearer ${token}` });
            AxiosInstance.defaults.headers.common['Authorization'] = Singleton.getInstance().authCredencials.token();
            return token;
        }),
    airports: () => AxiosInstance.get('airports'),
    airportsByIata: throttle(iata => (iata !== '') ? AxiosInstance.get(`crew/airports/`, {
        data: 'airportsByIata',
        params: {
            iata: iata,
        }
    }) : null, interval),
    content_role: () => AxiosInstance.get('resources/content_role'),
    airportsByIataCached: searchValue => {
        if (searchValue !== '') {
            let firstLetter = searchValue[0];
            if (Singleton.getInstance().airportsNameStore.lexicalKeyExist(firstLetter)) {
                return new Promise((resolve) => {
                    let d = { "data": Singleton.getInstance().airportsNameStore.getLexicalValueByKey(firstLetter) };
                    resolve(d);
                });
            } else {
                return AxiosServices.airportsByIata(searchValue[0]);
            }
        }
    },
    stock: (shop, uuids) => AxiosInstance.get(`crew/shops/${shop}/stocks`, { params: { uuid: uuids } }),
    orders: () => AxiosInstance.get('crew/orders', "orders"),
    ordersByFilters: filters => AxiosInstance.get(`orders`, { data: "ordersByFilters", params: { filters } }),
    ordersWorkflow: () => AxiosInstance.get(`crew/orders/workflow`),
    productsByShop: (shop = 'art-shop', lng = 'en_US') => AxiosInstance.get(`crew/shops/${shop}/products`, {
        data: 'productsByShop',
        params: {
            locale: lng
        }
    }),
    shops: () => AxiosInstance.get('crew/shops'),
    shopsByFilters: filters => AxiosInstance.get(`shops`, { data: "filters", params: { filters } }),
    pushNotification: locale => AxiosInstance.post(`crew/push/notifications`, { ...locale }),
    getShopStats: uuid => AxiosInstance.get(`crew/shops/${uuid}/stats`, { data: "getShopStats" }),
    putOrderStatus: (uuid, order) => AxiosInstance.put(`crew/orders/${uuid}/status`, order),
    putShopStatus: (uuid, status) => AxiosInstance.put(`crew/shops/${uuid}/status`, { status: status }),
    putStock: (uuid, quantity) => AxiosInstance.post(`crew/stocks`, [{
        retail_product_uuid: String(uuid),
        quantity: quantity
    }]),
};

export default AxiosServices;